module.exports = __webpack_public_path__ + "static/media/trash-red.de1f85f6.svg";